// keycloak.ts

import config from "src/config";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const keycloakConfig = {
  url: config.AUTH_HOST_KEYCLOAK_URL,
  realm: config.REALM,
  clientId: config.CLIENT_ID,
};

export default keycloakConfig;
